import * as React from "react";
import { type IconProps, iconProps } from "../util/IconProps";
export function CheckmarkCircleFilledIcon(props: IconProps): React.JSX.Element {
  const { color, size, ...rest } = iconProps(props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm5.234 6.927a.75.75 0 0 1 .089 1.057l-6.333 7.5a.75.75 0 0 1-1.123.026L6.7 13.101a.75.75 0 0 1 1.1-1.02l2.59 2.788 5.787-6.853a.75.75 0 0 1 1.057-.089Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
